import React from 'react'
import { Skeleton, Typography, Form, Input, Transfer, Button, Divider, Row, Col, Space, message, Switch } from 'antd'
import { PlusCircleOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { FormComponent, BaseFormComponentProps } from '../../../BaseComponent'
//import KennelCard from '../../../KennelCard'
import { ImageUpload } from '../../../Upload'
import { parserQuestionForm } from '../../../../helpers/kennel-card.helper'
import IShelter from '../../../../interfaces/IShelter'
import IKennelCardQuestion from '../../../../interfaces/IKennelCardQuestion'
import Config from '../../../../config'

type KennelCardConfigProps = BaseFormComponentProps & {
  uuid: string,
  loading: boolean,
  contentLoading: boolean,

  shelter: IShelter | null,

  data: {
    type_key: string,
    value: {
      pet_info: {
        pet_info_fields: string[]
      },
      questions_title: string,
      questions: IKennelCardQuestion[]
    }
  },

  loadShelter: (args: any) => Promise<void>,

  loadShelterSetting: (args: any) => Promise<void>,
  dispatchSave: (args: any) => void
}

export default class KennelCardConfig extends FormComponent<KennelCardConfigProps> {

  state = {
    loaded: false,
    saving: false,
    fileList: [] as any[],
    selectedInfo: [] as string[],
    form: {
      qr_code_title: 'SCAN TO GET MORE INFO',
      block_pet_restricted_and_hidden: false,
      questions_title: '',
      questions: []
    }
  }

  formRef = null as any

  private petInfoOptions = [
    {
      key: 'breed_primary',
      title: 'Primary Breed',
      mockValue: 'German Rex'
    },
    {
      key: 'breed_secondary',
      title: 'Secondary Breed',
      mockValue: 'Aegean'
    },
    {
      key: 'specie',
      title: 'Species',
      mockValue: 'Cat'
    },
    {
      key: 'sex',
      title: 'Sex',
      mockValue: 'Female'
    },
    {
      key: 'age',
      title: 'Age',
      mockValue: 'Adult'
    },
    {
      key: 'size',
      title: 'Size',
      mockValue: 'Growing'
    },
    {
      key: 'branch',
      title: 'Location',
      mockValue: 'Headquarter'
    },
    {
      key: 'status',
      title: 'Status',
      mockValue: 'Available'
    },
    {
      key: 'created_date',
      title: 'Created At',
      mockValue: '10/01/2020'
    },
    {
      key: 'application_approved_date',
      title: 'Approved At',
      mockValue: '05/02/2020'
    },
    {
      key: 'application_adopted_date',
      title: 'Adopted At',
      mockValue: '20/02/2020'
    },
    {
      key: 'custom_code',
      title: 'Custom Code',
      mockValue: 'weqra'
    },
    {
      key: 'global_code',
      title: 'Global Code',
      mockValue: 'wttyjj'
    },
    {
      key: 'archived',
      title: 'Archived',
      mockValue: 'Not'
    },
    {
      key: 'kennel_number',
      title: 'Kennel Number',
      mockValue: '5'
    },
    {
      key: 'microchip',
      title: 'Microchip',
      mockValue: '123456789'
    },
    {
      key: 'neutered',
      title: 'Spay/Neuter',
      mockValue: 'No'
    }
  ]

  static getDerivedStateFromProps(props: any, state: any) {
    if (props.data && !state.loaded) {
      const { value } = props.data

      if (typeof value === 'object') {
        state.selectedInfo = value.pet_info || []

        state.form = {
          qr_code_title: value.qr_code_title || 'SCAN TO GET MORE INFO',
          block_pet_restricted_and_hidden: value.block_pet_restricted_and_hidden || false,
          questions_title: value.questions_title,
          questions: value.questions.map(question => {
            return {
              value: question.title,
              answers: question.options.map(option => {
                return {
                  value: option
                }
              }) 
            }
          })
        }
      }
    }
    
    if (props.shelter && !state.loaded) {
      const { uuid, kennel_card_logo } = props.shelter

      if (kennel_card_logo && kennel_card_logo.length > 0) {
        state.fileList = [{
          uid: uuid,
          url: `${Config.cdnImagesBase}organization/shelter/kennel_card_logo/AUTOx200/${kennel_card_logo}`,
          status: 'done'
        }]
      }
    }

    if (props.data && props.shelter && !state.loaded) {
      state.loaded = true
    }

    if (state.loaded) {
      if (!state.saving && props.loading) {
        state.saving = true
      }
      if (state.saving && !props.loading) {
        state.saving = false

        if (props.error) {
          message.error(`Could not save Kennel Card configuration. Reason: ${props.error}`)
        } else {
          message.success('Kennel Card configuration saved!')
        }
      }
    }

    return state
  }

  async componentDidMount() {
    const { uuid, data, shelter, loadShelterSetting, loadShelter } = this.props

    // Validate permissions
    this.validateAccessPermissions()

    if (!data) {
      await loadShelterSetting({
        search: {
          organization_shelter: {
            has: {
              uuid
            }
          }
        }
      })
    }

    if (!shelter) {
      await loadShelter({
        search: {
          uuid,
          contract_options: {
            with: true
          },
          organization_question_shelters: {
            with: {
              deleted: false,
              kiosk_reason_id: null,
              question_shelter_species: {
                with: true
              }
            }
          },
          organization_branches: {
            with: true
          }
        },
        options: {
          _force_ids: true
        }
      })
    }

    this.setState({loaded : true})


  }

  private getLogo() {
    const { shelter } = this.props
    const { fileList } = this.state

    if (shelter) {
      if (fileList.length > 0) {
        const logo = fileList[0]
        if (logo.url.includes('data:image')) {
          return logo.url
        }
      }

      if (shelter.kennel_card_logo) {
        return `${Config.cdnImagesBase}organization/shelter/kennel_card_logo/AUTOx100/${shelter?.kennel_card_logo}`
      }

      if (shelter.logo) {
        return `${Config.cdnImagesBase}organization/shelter/logo/AUTOx100/${shelter?.logo}`
      }
    }

    return ''
  }

  handleImageUploadChange = (fileList) => {
    this.setState({
      fileList
    })
  }

  handleFormChange = (values: any) => {
    const { qr_code_title, block_pet_restricted_and_hidden, questions_title, questions } = values
    let newState = Object.assign({}, this.state)
    
    newState.form.qr_code_title = qr_code_title
    newState.form.questions_title = questions_title
    newState.form.block_pet_restricted_and_hidden = block_pet_restricted_and_hidden

    if (questions) {
      newState.form.questions = questions.filter(p => typeof p === 'object' && p.value).map(question => {
        if (question.answers === undefined) {
          question.answers = [undefined]
        }

        return question
      })
    }

    if (newState !== this.state) {
      this.setState(newState)
    }
  }

  handlePetInfoSelection = (targetKeys: string[], direction: string, moveKeys: any) => {
    if (this.state.selectedInfo.length >= 8 && direction === 'right') {
      return targetKeys
    }

    this.setState({
      selectedInfo: targetKeys.slice(0, 8)
    })
  }

  handleSave = (values: any) => {
    const { uuid, dispatchSave } = this.props
    const { fileList, selectedInfo } = this.state
    const { questions_title } = values
    const questions = parserQuestionForm(values.questions)

    let payload: any = {
      shelter_uuid: uuid,
      type_key: 'KENNEL_CARD',
      value: {
        pet_info: selectedInfo,
        block_pet_restricted_and_hidden: this.state.form.block_pet_restricted_and_hidden || false,
        qr_code_title: this.state.form.qr_code_title,
        questions_title,
        questions
      }
    }

    if(selectedInfo?.length === 0){
      message.error(`Could not save Kennel Card configuration. Reason: Pet Info is required.`)
      return
    }

    if (fileList.length > 0) {
      // Parse logo to request
      const logo = fileList[0]
      if (logo.url.includes('data:image')) {
        payload = {
          ...payload,
          kennel_card_logo: logo.url
        }
      }
    } else {
      payload = {
        ...payload,
        kennel_card_logo: null
      }
    }

    dispatchSave(payload)
  }

  renderQuestions = () => {
    return (
      <Form.List name="questions">
        {(fields, { add, remove }) => {
          return (
            <>
              {
                fields.map(field => (
                  <div key={field.key} style={{marginBottom: 8}}>
                    <Space style={{ display: 'flex' }} align="start">
                      <Form.Item
                        {...field}
                        name={[field.name, 'value']}
                        fieldKey={[field.fieldKey, 'value']}
                        rules={[
                          {
                            required: true,
                            message: 'Missing question'
                          }
                        ]}
                      >
                        <Input.TextArea placeholder="Question" rows={3} cols={50} maxLength={120} />
                      </Form.Item>

                      <MinusCircleOutlined onClick={() => {
                        remove(field.name)
                        this.handleFormChange(this.formRef.getFieldsValue())
                      }} />
                    </Space>
                    
                    {this.renderAnswers(`${field.name}`)}
                  </div>
                ))
              }

              {/*<Form.Item>
                <Button disabled={fields.length === 6} type="dashed" block onClick={() => add()}>
                  <PlusCircleOutlined /> Add more pet characteristics
                </Button>
            </Form.Item>*/}
            </>
          )
        }}
      </Form.List>
    )
  }

  renderAnswers = (questionName: string) => {
    return (
      <div style={{width: '80%'}}>
        <Form.List name={[questionName, 'answers']}>
          {(fields, { add, remove }) => {
            return (
              <>
                {
                  fields.map(field => (
                    <Row key={field.key} gutter={12} style={{marginBottom: 3}}>
                      <Col xs={20}>
                        <Form.Item
                          {...field}
                          name={[field.name, 'value']}
                          fieldKey={[field.fieldKey, 'value']}
                          rules={[
                            {
                              required: true,
                              message: 'Missing answer'
                            }
                          ]}
                        >
                          <Input placeholder="Answer" maxLength={120} />
                        </Form.Item>
                      </Col>

                      <Col xs={4}>
                        <MinusCircleOutlined onClick={() => {
                          remove(field.name)
                          this.handleFormChange(this.formRef.getFieldsValue())
                        }} />
                      </Col>
                    </Row>
                  ))
                }

                <Form.Item>
                  <Button disabled={fields.length === 6} type="dashed" block onClick={() => add()}>
                    <PlusCircleOutlined /> Add more characteristics
                  </Button>
                </Form.Item>
              </>
            )
          }}
        </Form.List>
      </div>
    )
  }

  render() {
    const { loading } = this.props
    const { fileList, selectedInfo, form, loaded } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    /*const petInfo = this.petInfoOptions.filter(info => selectedInfo.includes(info.key)).map(info => {
      return {
        field: info.title,
        value: info.mockValue
      }
    })

    // Just for mocking preview
    const shelterImage = this.getLogo()
    const petUrl = 'https://adopt.adopets.com/pet/c7b998f6-df55-42a9-9ebd-08304c145dbc?tracking=7e142c2f-8beb-4fc7-b523-ab8fad88629b'
    const petName = 'Eva'
    const petId = '123456789'
    const petMicrochip = '123456789'
    const petDescription = `
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec eu blandit nisi. Vestibulum id nunc eget mi feugiat maximus.
      Curabitur elit nibh, congue et aliquam sit amet, vehicula lobortis velit. Sed aliquam dictum mauris et accumsan.
      Duis vel tempus purus, et varius dui.
    `*/

    return (
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center'}}>
          {/*<KennelCard
            shelterImage={shelterImage}
            qrCodeTitle={form.qr_code_title}
            petUrl={petUrl}
            petName={petName}
            petId={petId}
            petMicrochip={petMicrochip}
            petDescription={petDescription}
            petInfo={petInfo}
            questions_title={form.questions_title}
            questions={parserQuestionForm(form.questions)}
      />*/}

        <Divider />

        <Form
          name="kennel_card"
          layout="vertical"
          initialValues={form}
          ref={(refs: any) => this.formRef = refs}
          onFinish={this.handleSave}
          style={{width: '100%'}}
        >
          <Typography.Title level={4}>Settings</Typography.Title>

          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item
                label={<b>QR Code Title</b>}
                name="qr_code_title"
              >
                <Typography.Text>This is the short title for the Kennel Card Application QR Code. Shelters can customize to have a custom Call To Action based on their preferred language. In essence, it allow adopters to submit inquiries/applications to pets when visiting them in person.</Typography.Text>
                <br/><br/>
                <Input value={this.state.form.qr_code_title} onChange={(e) => this.handleFormChange({ ...this.state.form, qr_code_title: e.target.value })}/>
              </Form.Item>

              <Form.Item
                label={<b>Block QR Code Scan for pets that are Restricted and Hidden.</b>}
                name="block_pet_restricted_and_hidden"
                valuePropName="checked"
              >
                <Typography.Text>This prevents adopters from submitting adoption inquiries/applications to animals whose visibility is set to Hidden or Restricted (when the pet has reached its application limit).</Typography.Text>
                <br/><br/>
                <Switch checked={this.state.form.block_pet_restricted_and_hidden} onChange={(e) => this.handleFormChange({ ...this.state.form, block_pet_restricted_and_hidden: e })}/>
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Typography.Title level={5}>Shelter logo on Kennel Card</Typography.Title>
              <Typography.Text>The shelter logo on the kennel card must follow these requirements. It must be a JPG and placed on a 300px (width) by 115px (height) white frame. That way, we prevent the logo from being distorted when rendering kennel cards.</Typography.Text>
              <br/><br/>
              <ImageUpload
                name="kennel_card_logo"
                fileList={fileList}
                accept={"image/jpeg,image/jpg"}
                aspect={4 / 3}
                className="kennel-card-logo-uploader"
                onChange={this.handleImageUploadChange}
              />
            </Col>
          </Row>

          <Divider />

          <Typography.Title level={4}>Configure pet information data points on kennel card</Typography.Title>
          <Typography.Text>This allows you to configure specific pet information to display on kennel cards. When configured, the pet information data points below, placed on the right, will be available on all the Kennel Card types in the Rescue Platform.</Typography.Text>
          <br/><br/>
          <Transfer
            dataSource={this.petInfoOptions}
            targetKeys={selectedInfo}
            render={(item: any) => item.title}
            onChange={this.handlePetInfoSelection}
          />

          <Divider />

{/*<Typography.Title level={4}>Pet Characteristics</Typography.Title>

          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Title"
                name="questions_title"
              >
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              {this.renderQuestions()}
            </Col>
    </Row>*/}

          <Button type="primary" htmlType="submit" loading={loading} size="large" ref={(refs) => this.actionRefs.save = refs} block style={{marginBottom: 15}}>
            Save
          </Button>
        </Form>
      </div>
    )
  }
}
